<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Group Name -->
      <b-form-group
        label="Group Name"
        label-for="mc-group-name"
      >
        <validation-provider
          #default="{ errors }"
          name="Group Name"
          rules="required"
        >
          <b-form-input
            v-model="item.groupName"
            :state="errors.length > 0 ? false:null"
            placeholder="Group Name"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        label="Group Permissions"
      >
        <b-row>
          <b-col
            v-for="(perm,index) in permissionList"
            :key="index"
            md="6"
          >
            <b-form-checkbox

              :id="'mc-boxconfig-'+perm.code"

              v-model="perm.value"
              class="mt-1"
              :name="'mc-boxconfig-'+perm.code"
              switch
            >
              {{ perm.label }}
            </b-form-checkbox>
          </b-col>

        </b-row>
      </b-form-group>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormCheckbox, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        groupName: null,
        permissionsJson: null,
        permissions: null,
      },
      permissionList: [
        {
          group: 'Page', code: 'addNewPage', label: 'Add New Page', value: false,
        },
        {
          group: 'Page', code: 'setPageLayout', label: 'Set Page Layout', value: false,
        },
        {
          group: 'Page', code: 'editPage', label: 'Edit Page', value: false,
        },
        {
          group: 'Page', code: 'exportPage', label: 'Export Page', value: false,
        },
        {
          group: 'Page', code: 'exportPagePdf', label: 'Send page as PDF', value: false,
        },
        {
          group: 'Page', code: 'deletePage', label: 'Delete Page', value: false,
        },
        {
          group: 'Box', code: 'addBox', label: 'Add Box', value: false,
        },
        {
          group: 'Box', code: 'editBox', label: 'Edit Box', value: false,
        },
        {
          group: 'Box', code: 'searchBox', label: 'Search Box', value: false,
        },
        {
          group: 'Box', code: 'cloneBox', label: 'Clone Box', value: false,
        },
        {
          group: 'Box', code: 'deleteBox', label: 'Delete Box', value: false,
        },
        {
          group: 'Box', code: 'exportBox', label: 'Export Box', value: false,
        },
        {
          group: 'Hot Alert', code: 'seeHotAlert', label: 'See Hot Alert', value: false,
        },
        {
          group: 'Approvals', code: 'seeApprovals', label: 'See Approvals', value: false,
        },
        {
          group: 'Appeals', code: 'seeAppeals', label: 'See Appeals', value: false,
        },
        {
          group: 'Manage Appeals', code: 'manageAppeals', label: 'Manage Appeals', value: false,
        },
        {
          group: 'Message', code: 'messageManagement', label: 'Message Management', value: false,
        },
        {
          group: 'My Dashboard', code: 'myDashboard', label: 'My Dashboard', value: false,
        },
        {
          group: 'Multimedia', code: 'multimedia', label: 'Multimedia', value: false,
        },
        {
          group: 'Request', code: 'request', label: 'Request', value: false,
        },
        {
          group: 'Request', code: 'requestEdit', label: 'Request Edit', value: false,
        },
        {
          group: 'Request', code: 'requestDelete', label: 'Request Delete', value: false,
        },
        {
          group: 'AI Summary', code: 'aiSummary', label: 'AI Summary', value: false,
        },
        {
          group: 'AI Chat', code: 'aiChat', label: 'AI Chat', value: false,
        },
      ],
      required,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value && this.value.permissionsJson) {
          const perms = JSON.parse(this.value.permissionsJson)
          perms.forEach(p => {
            const perm = this.permissionList.find(x => x.code === p.code && p.value)
            if (perm) {
              perm.value = true
            }
          })
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.item.permissionsJson = JSON.stringify(this.permissionList.filter(x => x.value))
          if (this.item.id) {
            useJwt.axiosIns.patch('usergroup', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('usergroup', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>
